import AddressService from "./address.service";

let inject = [
    '$scope',
    'AddressService',
    '$state',
    '$rootScope',
    'SharedService',
    '$timeout',
    'ngAuthSettings',
    'SessionService',
    'NgTableParams',
    '$mdToast',
    '$uibModal'
];

class AddressController {

    constructor($scope,
                AddressService,
                $state,
                $rootScope,
                SharedService,
                $timeout,
                ngAuthSettings,
                SessionService,
                NgTableParams,
                $mdToast,
                $uibModal) {

        this.$scope = $scope;
        this.AddressService = AddressService;
        this.$state = $state;
        this.SessionService = SessionService;
        this.ngAuthSettings = ngAuthSettings;
        this.NgTableParams = NgTableParams;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.$uibModal = $uibModal;
        this.$mdToast = $mdToast;
        this.SharedService = SharedService;
        this.newDirection = {};
        this.directions = [];
        this.showError = null;
        this.showSuccess = null;
        this.directionSave = {};
        this.showErrorAlone = null;
        this.locationsByFastSearch = [];
    }

    $onInit() {
        this.initComponents();
    }
    
    initComponents() {
        let userId = '';
        try {
            userId = this.shCtrl.globals.currentUser.userId;
        }
        catch (e) {
        }
        
        this.AddressService.getAllDirections(userId).then(response => {
            
            if(!response.error){
                this.directions = [];
                angular.forEach(response.data, (value, key) => {
                    value.principal = value.principal === 1;
                    value.showSuccess = null;
                    value.showErrorAlone = null;
                    value.pending = false;
                    this.directions.push(value);
                });
            }
        });
    }

    selectFavorite(address) {

        if (!address.principal) {
            if (address.id && !this.directions.some((val) => {
                return val.principal && val.id !== address.id;
            })) {
                address.principal = true;
                if(__env.adaptative){
                  this.messageMaterial('Debes tener una dirección como principal');
                }else{
                  this.showError = 'Debes tener una dirección como principal';
                  showErrorsDirection();
                }
            }
        } else if (this.directions.length) {
            if (this.directions.some((val) => {
                return val.principal && val.id !== address.id;
            })) {
                if (!__env.adaptative) {
                    address.pending = true;
                    showConfirmPrincipalDirection(address);
                }
            }
        }
    }

    cancelChangePrincipalDirection() {
        this.newDirection.principal = false;
    }

    getLocationsByFastSearch(address) {

        var addressCopy = {};
        angular.merge(addressCopy, address);
        
        if (!address.ciudad) {

            addressCopy.ciudadId = null;
            addressCopy.directionSave = null;
            addressCopy.locationsByFastSearch = [];
            angular.merge(address, addressCopy);
            
            return;
        }

        addressCopy.ciudadId = null;
        addressCopy.directionSave = null;

        if (address.ciudad.length > 3) {
            
            addressCopy.locationsByFastSearch = [];

            this.AddressService.locationBySearchText(address.ciudad).then((response) => {
                
                addressCopy.locationsByFastSearch = response;
                angular.merge(address, addressCopy);
            });
        }
        
        angular.merge(address, addressCopy);
        
    }

    setLocationCity(location, address) {

        var addressCopy = {};
        angular.merge(addressCopy, address);
        addressCopy.ciudad = location.cityName + ', ' + location.stateName + ' - ' + location.countryName;
        addressCopy.ciudadId = location.cityId;
        addressCopy.directionSave = location;
        addressCopy.locationsByFastSearch = [];
        angular.merge(address, addressCopy);
        address.ciudadId = location.cityId;
        address.locationsByFastSearch = [];
    }

    saveDirection(direction, directionForm) {
        
        if (directionForm.$valid && direction.ciudadId) {
            
            /*if (this.directions.length) {
                if (!this.directions.some((val) => {
                    return val.principal;
                }) && !this.newDirection.principal) {

                    this.showError = 'Debes seleccionar una dirección como principal';
                    this.showErrorsDirection();
                    return;
                }º
            }*/

            let userId = '';
            try {
                userId = this.shCtrl.globals.currentUser.userId;
            }
            catch (e) {
            }
            
            var copyDirection = angular.copy(direction);
            copyDirection["usuarioId"] = userId;
            if (!copyDirection.principal) copyDirection.principal = 0;

            this.AddressService.saveDirection(copyDirection).then((response) => {
                if (response.error) {
                    
                    direction.showErrorAlone = response.message;

                    this.$timeout(() => {
                        direction.showErrorAlone = null;
                    }, 1500);

                } else {
                    if(__env.adaptative){
                      this.messageMaterial(response.message);
                    }else{
                    //   this.showSuccess = response.message;
                        direction.showSuccess = response.message;
                    }
                    
                    this.clearForm(directionForm);

                    this.$timeout(() => {
                        direction.showSuccess = null;
                    }, 1500);

                    this.initComponents();
                }

            });
        } else {
            this.directionForm = angular.copy(directionForm);
            if(!__env.adaptative) { showRegisterErrorsModal(); }
            
        }
    }

    editDirection(direction) {

        if(__env.adaptative) {
            this.newDirection = angular.copy(direction);
        }
    }

    deleteDirection(direction) {
        if (direction.principal) {
            if(__env.adaptative){
              this.messageMaterial('Debes tener una dirección como principal');
            }else{
              this.showError = 'Debes tener una dirección como principal';
              showErrorsDirection();
            }

        } else {
            this.AddressService.deleteDirection(direction.id).then((response) => {
                if (response.error) {
                    if(__env.adaptative){
                      this.messageMaterial(response.message);
                    }else{
                      direction.showErrorAlone = response.message;
                    }

                    this.$timeout(() => {
                        direction.showErrorAlone = null;
                    }, 1500);

                } else {
                    if(__env.adaptative){
                      this.messageMaterial('Dirección eliminada correctamente');
                    }else{
                      direction.showSuccess = 'Dirección eliminada correctamente';
                    }

                    this.$timeout(() => {
                        direction.showSuccess = null;
                    }, 2500);
                    this.initComponents();
                }
            });
        }
    }

    clearError() {
        this.showError = null;
    }

    clearForm(form) {
        this.newDirection = {};
        this.locationsByFastSearch = [];
        form.$setPristine();
    }

    messageMaterial(text) {

        var mdToast=this.$mdToast;
        this.$mdToast.show({
        hideDelay   : 7000,
        controller  : function () {
            this.closeToast = function(){
            mdToast.hide();
            }

        },
        controllerAs:'toast',
        template : '<md-toast>\n' +
        '  <span class="md-toast-text">'+ text +'</span>\n' +
        '  <md-button ng-click="toast.closeToast()">\n' +
        '    Cerrar\n' +
        '  </md-button>\n' +
        '</md-toast>'
        });
    }

    principalDirection(response) {

        var directionsCopy = [];
        angular.merge(directionsCopy, this.directions);

        directionsCopy.forEach((address) => {
            address.principal = false;
            if (address.pending) {
                address.pending = false;
                address.principal = response;
            }
        });
        angular.merge(this.directions, directionsCopy);
    }

}

AddressController.$inject = inject;

export default AddressController;




// WEBPACK FOOTER //
// ./www/components/address/address.controller.js